import React from 'react';

const PHEDThresholdSpeed = ({ data: { thresholdSpeed } }) =>
  thresholdSpeed ? <p>{`${thresholdSpeed} mph`} </p> : null;

export default PHEDThresholdSpeed;
